/**
 * Feature flags for the top-level Drafting feature.
 *
 * DRAFTING_READ_ONLY — the first release ships read-only: no in-app editing and
 * NO collaborative (Yjs) socket connection. The document is viewed (markdown or
 * DOCX preview) and downloaded as Word; editing/collaboration is deferred.
 * Flip to false to re-enable the collaborative editor.
 */
export const DRAFTING_READ_ONLY = true;

/**
 * DRAFTING_SHARING_ENABLED — sharing a drafted document with colleagues.
 *
 * The frontend is complete and is the same one Tables uses: the shared Access
 * pane (READ) plus the shared manage-access side panel (WRITE), over the
 * adapter contract in `utils/collaboratorAdapters/types`. What does not exist
 * yet is the BACKEND:
 *
 *   GET|POST   /drafting/{drafts|insights}/{uuid}/collaborators
 *   PUT|DELETE /drafting/{drafts|insights}/{uuid}/collaborators/{collabUuid}
 *
 * plus `shared_with` on the detail GET. Those mirror `/tables/:uuid/…` exactly,
 * so `accessModel.normalise` needs no new keys.
 *
 * OFF ships the page as it is: no Access pane, no rail pill, no avatar stack.
 * Flip this to `true` once those routes are deployed — nothing else changes.
 */
export const DRAFTING_SHARING_ENABLED = false;
